module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 313
// module chunks = 0